import PageHero from '../components/PageHero.jsx';

export default function NotFound() {
  return (
    <PageHero label="Page not found" title="Let’s get you back to the movement." intro="The page you requested is not part of this chapter yet.">
      <a className="button button--gold" href="/">Return home</a>
    </PageHero>
  );
}
